import { getMaxFfl } from "@project-rouge/rg-three";
function isBuildingSprinklered(building, aggConfig) {
	const maxFfl = getMaxFfl(building);
	const { sprinkleredFflThreshold } = aggConfig;
	return maxFfl >= sprinkleredFflThreshold;
}
export { isBuildingSprinklered };

//# sourceMappingURL=index47.js.map